<!--Wrapper component for functional SVG and material icons,
it uses 'v-icon' css class to extend base v-icon functionality-->
<template>
    <span
        :class="[
            'v-icon',
            { 'v-icon--x-small': xSmall },
            { 'v-icon--small': small },
            { 'v-icon--medium': medium },
            { 'v-icon--large': large },
            { 'v-icon--right': right },
            { 'v-icon--left': left },
            { 'v-icon--disabled': disabled },
            iconColourType ? 'v-icon--' + iconColourType : '',
            color ? color + '--text' : '',
        ]"
    >
        <component :is="iconName" v-if="getComponent(iconName)" />
        <v-icon v-else :class="iconClass" :size="size" :color="color">
            {{ iconName }}
        </v-icon>
    </span>
</template>

<script setup>
import { getCurrentInstance, computed } from 'vue';

const props = defineProps({
    xSmall: Boolean,
    small: Boolean,
    medium: Boolean,
    large: Boolean,
    right: Boolean,
    left: Boolean,
    color: String,
    iconColourType: {
        type: String,
        validator: value => {
            return [
                'primary-rect',
                'primary-path',
                'secondary-rect',
                'secondary-path',
                'positive-rect',
                'positive-path',
            ].includes(value);
        },
    },
    iconName: String,
    disabled: Boolean,
    materialIconClass: String,
    size: [String, Number],
});

const instance = getCurrentInstance();

const iconClass = computed(() => [
    { 'v-icon--x-small': props.xSmall },
    { 'v-icon--small': props.small },
    { 'v-icon--medium': props.medium },
    { 'v-icon--large': props.large },
    props.materialIconClass,
    'notranslate',
    'material-icons',
    'v-theme--light',
]);

const getComponent = name => instance.appContext.components[name];
</script>

<style scoped lang="scss">
@import '@style/base/_variables.scss';

.v-icon {
    &--x-small {
        font-size: 1.2rem !important;
        height: 1.2rem;
    }
    &--small {
        font-size: 1.6rem !important;
        height: 1.6rem;
    }
    &--medium {
        font-size: 2rem !important;
        height: 2rem;
    }
    &--large {
        font-size: 3.6rem !important;
        height: 3.6rem;
    }
    svg {
        pointer-events: none;
    }
    &--primary-rect {
        :deep(svg rect) {
            fill: $promo-primary-colour;
        }
        &:hover {
            :deep(svg rect) {
                fill: $rtls-secondary-button-hover-colour;
            }
        }
    }
    &--primary-path {
        :deep(svg path) {
            fill: $promo-primary-colour;
        }
        &:hover {
            :deep(svg path) {
                fill: $rtls-secondary-button-hover-colour;
            }
        }
    }
}
</style>
